export const IconGrayUsersAllCandidates: {
  name: 'icon_gray_users_all_candidates-a030ca6c715e'
} = {
  name: 'icon_gray_users_all_candidates-a030ca6c715e'
}
